import React from "react";
import Skeleton from "./Skeleton";

function SkeletonPaymentItem() {
  return (
    <div className="payment-item sk-pay-item">
      <Skeleton width={32} height={32} borderRadius="10px" />
      <div className="payment-item__meta">
        <Skeleton width={56} height={13} />
        <Skeleton width={120} height={11} className="sk-pay-sub" />
      </div>
      <Skeleton width={70} height={13} className="sk-pay-amt" />
    </div>
  );
}

export default SkeletonPaymentItem;
